/*=========================================================================================
  File Name: configuration.js
  Description: Default configuration. Store general config information.
==========================================================================================*/

const baseURL = process.env.VUE_APP_API_BASE_URL;

export { baseURL };
